import React from 'react';

import {MainLayout} from 'widgets/layout';
import {Cities} from 'features/admin';

const AdminCitiesPage: React.FC = () => {

    return (
        <MainLayout>
            <Cities />
        </MainLayout>
    );
};

export default AdminCitiesPage;